import { gql } from "@apollo/client"
import craftApolloClient from "./api/apollo"

import Head from "next/head"

import { HeaderShim } from "../fuselage/global/header/header"
import { FooterShim } from "../fuselage/global/footer/footer"
import handleSeomaticMeta from "../lib/seomatic"
import handleContentBlocks from "../lib/content-blocks"


import { 
    QueryText, 
    QueryFlipFlops, 
    QueryFloaters, 
    QueryBillboards, 
    QueryBillboardSliders, 
    QueryImpactFigures, 
    QueryVideos,
    QueryForm,
    QueryProfileCarousel,
    QueryPageHeader,
    QueryCards,
    QueryOffsetCallout,
    QueryDividers,
    QuerySEO,
    QueryPartners,
    QueryTestimonials,
    QueryCustomSliderVideo,
    QueryCustomQuoteImageGrid
} from "../graphql/queries"




export default function Page ({ seomatic, entry }) {

    // console.log('seomatic:', seomatic)
    // console.log('entry:', entry) 
  
    return (
        <div style={{ width: `100%`, overflow: `hidden` }}>

            <Head>
                { handleSeomaticMeta( seomatic ) }
            </Head>

            <HeaderShim />
            
            {handleContentBlocks( entry.ahifContentBlocks )}

        </div>
    )
}


export async function getStaticPaths() {

    const entriesData = await craftApolloClient().query({
        query: gql`
            query Pages {
                entries(site: "${process.env.SITE_HANDLE}", section: "${process.env.SITE_HANDLE}Pages") {
                    slug
                }
            }
        `
    })

    const entries = await entriesData.data.entries

    return {
        paths: entries.map( entry => ({ params: { slug: entry.slug } })),
        fallback: false
    }

}

export async function getStaticProps({ params, preview, previewData }) {

    const entryData = await craftApolloClient( preview, previewData ).query({
        query: gql`
            query Page {
                entry(site: "${process.env.SITE_HANDLE}", slug: "${params.slug}") {
                    ... on ${process.env.SITE_HANDLE}Pages_page_Entry {
                        id
                        title
                        slug
                        ${process.env.CONTENT_BLOCKS_HANDLE}ContentBlocks {
                            ${QueryText}
                            ${QueryFlipFlops}
                            ${QueryFloaters}
                            ${QueryBillboards}
                            ${QueryBillboardSliders}
                            ${QueryImpactFigures}
                            ${QueryVideos}
                            ${QueryProfileCarousel}
                            ${QueryOffsetCallout}
                            ${QueryPageHeader}
                            ${QueryDividers}
                            ${QueryCards}
                            ${QueryForm}
                            ${QueryPartners}
                            ${QueryTestimonials}
                            ${QueryCustomSliderVideo}
                            ${QueryCustomQuoteImageGrid}
                        }
                        ${QuerySEO}
                    }
                }
            }
        `
    })

    const page = entryData

    return { props: 
        { 
            entry: page.data.entry, 
            seomatic: page.data.entry.seomatic
        }
    }
}